export default {
  NOT_STARTED: "NOTSTARTED",
  PROCESSING: "PROCESSING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
};
